import { userComments } from '@/mocks/data';

export default function CommentSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 rounded-full">
            <span className="w-2 h-2 bg-accent-500 rounded-full"></span>
            <span className="text-xs font-medium text-accent-700">网友热评</span>
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl font-heading text-foreground-950">
            吃瓜神评合集
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {userComments.slice(0, 5).map((comment, idx) => {
            const isPhotoCard = idx === 2;
            const isWideCard = idx === 3;

            if (isPhotoCard) {
              return (
                <div
                  key={comment.id}
                  className="relative rounded-lg overflow-hidden h-64 group"
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20reading%20news%20on%20smartphone%20with%20surprised%20expression%2C%20warm%20indoor%20lighting%2C%20cozy%20cafe%20atmosphere%2C%20editorial%20portrait%20style%2C%20soft%20golden%20light%2C%20candid%20moment%2C%20natural%20expression&width=500&height=600&seq=comment-photo-01&orientation=portrait"
                    alt="吃瓜网友"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <p className="text-white text-xl font-medium">{comment.avatar}</p>
                    <p className="text-white text-sm font-medium mt-1">{comment.name}</p>
                    <p className="text-white/70 text-xs mt-0.5">资深吃瓜群众</p>
                  </div>
                </div>
              );
            }

            if (isWideCard) {
              return (
                <div
                  key={comment.id}
                  className="md:col-span-2 relative rounded-lg overflow-hidden h-64 group"
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=Crowd%20of%20people%20looking%20at%20smartphones%20with%20excited%20expressions%2C%20warm%20evening%20lighting%2C%20urban%20street%20scene%2C%20editorial%20documentary%20style%2C%20golden%20hour%20glow%2C%20candid%20street%20photography%2C%20warm%20amber%20tones&width=800&height=500&seq=comment-wide-01&orientation=landscape"
                    alt="吃瓜热议"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-2xl">{comment.avatar}</span>
                      <div>
                        <p className="text-white text-sm font-semibold">{comment.name}</p>
                        <p className="text-white/60 text-xs">热心网友</p>
                      </div>
                    </div>
                    <p className="text-white/90 text-sm leading-relaxed line-clamp-2">
                      {comment.comment}
                    </p>
                  </div>
                </div>
              );
            }

            return (
              <div
                key={comment.id}
                className="bg-background-50 rounded-lg p-6 border border-background-200/60 transition-all duration-300 hover:scale-[1.02]"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-2xl">{comment.avatar}</span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{comment.name}</p>
                    <p className="text-xs text-foreground-500">吃瓜群众</p>
                  </div>
                </div>
                <div className="mb-4">
                  <i className="ri-double-quotes-l text-3xl text-primary-200"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {comment.comment}
                </p>
                <div className="flex items-center gap-1 mt-4 pt-4 border-t border-background-200/60 text-xs text-foreground-500">
                  <i className="ri-heart-line text-primary-400"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}